import { EmbedHtmlDocComponent } from 'src/components/embed-html-doc/embed-html-doc.component';
import { RenderValueComponent } from 'src/components/render-value/render-value.component';
import { SharedPipesModule } from 'src/modules/shared/shared-pipes.module';
import { FormRowComponent } from 'src/components/form-row/form-row.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BlockerComponent } from 'src/components/blocker/blocker.component';
import { HeroComponent } from 'src/components/hero/hero.component';
import { TranslocoModule } from '@jsverse/transloco';
import Helpers from 'src/shared/helpers';
import { ConfirmDialogCheckboxFooterComponent } from 'src/components/confirmdialog-checkbox-footer/confirmdialog-checkbox-footer.component';
import { BooleanDisplayComponent } from '@/components/boolean-display/boolean-display.component';
import { StatusIconComponent } from '@/components/status-icon/status-icon.component';
import { FileUploaderComponent } from '@/components/fileuploader/fileuploader.component';

const components = [
  BlockerComponent,
  ConfirmDialogCheckboxFooterComponent,
  FormRowComponent,
  HeroComponent,
  EmbedHtmlDocComponent,
  RenderValueComponent,
  BooleanDisplayComponent,
  StatusIconComponent,
  FileUploaderComponent,
];

@NgModule({
  imports: [
    SharedPipesModule,
    CommonModule,
    TranslocoModule,
    FormsModule,
    ...Helpers.primeNgModules,
  ],
  declarations: components,
  exports: components,
})
export class SharedComponentsModule {}
